import { Button, Checkbox, Row, Space } from "antd";
import { FilterConfirmProps } from "antd/lib/table/interface";
import React from "react";

type Props = {
  setSelectedKeys: (selectedKeys: React.Key[]) => void,
  selectedKeys: React.Key[],
  confirm: (param?: FilterConfirmProps) => void,
  clearFilters?: () => void,
  filters?: any[],
  dataIndex: string
}

/**
 * Custom filter dropdown to allow filter on checkbox select
 * @param props partial copy from `FilterDropdownProps` in antd/lib/table/interface
 * @returns custom filter dropdown
 */
const CustomFilterDropdown: React.FC<Props> = ({
  filters,
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  dataIndex
}) => {

  /**
   * uncheck filter selection
   */
  const uncheckFilterSelection = () => {
    const checkedCheckboxes = document.querySelector(`.custom-filter-dropdown.${dataIndex}`).getElementsByClassName('ant-checkbox-checked');
    while (checkedCheckboxes[0]) {
      checkedCheckboxes[0].classList.remove('ant-checkbox-checked');
    }
  }

  return (
    <div className={`custom-filter-dropdown ${dataIndex}`}>
      <div className="checkbox-list" style={{ maxHeight: "250px", overflow: "auto", padding: "8px" }}>
        <Space direction="vertical" className="full-width">
          {filters?.sort((a, b) => a.text.localeCompare(b.text)).map((filter) => {
            return <Row>
              <Checkbox
                value={filter.value}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, e.target.value]);
                  } else {
                    setSelectedKeys(selectedKeys.filter(key => key !== e.target.value));
                  }
                  confirm({ closeDropdown: false });
                }}
              >
                {filter.text}
              </Checkbox>
            </Row>
          })}
        </Space>
      </div>
      <div className="footer" style={{ borderTop: "1px solid #303030", padding: "8px" }}>
        <Button
          onClick={() => {
            uncheckFilterSelection();
            setSelectedKeys([]);
            clearFilters?.();
            confirm({ closeDropdown: true });
          }}
          size="small"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}

export default CustomFilterDropdown;